import { render, staticRenderFns } from "./ConfirmationDialogDuplicateProduct.vue?vue&type=template&id=0b64cecd"
import script from "./ConfirmationDialogDuplicateProduct.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialogDuplicateProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports